import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createCustomHeadCodeApi, customHeadCodeApiRelativePath } from './index';
import { createFakeGetResponder, createFakePutResponder, isWildcard } from '../../../test-utils';
export var createCustomHeadCodeApiApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createCustomHeadCodeApi('', fakeHttp);
    var testKit = {
        whenGetCustomHeadCode: function (dto) {
            return createFakeGetResponder(fakeHttp, customHeadCodeApiRelativePath + "/" + (isWildcard(dto) ? 'en' : "" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : '')));
        },
        whenUpdateCustomHeadCode: function (dto) {
            return createFakePutResponder(fakeHttp, customHeadCodeApiRelativePath + "/" + (isWildcard(dto) ? 'en' : dto.locale))(dto.data);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map